import PageHeader from "@/components/PageHeader";
import Pricing from "@/components/Pricing";
import CtaBand from "@/components/CtaBand";
import { useSeo } from "@/lib/seo";

export default function PricingPage() {
  useSeo({
    title: "Tickets & Prices | Cool Runnings Toboggan Park Cape Town",
    description:
      "Simple per-ride pricing at Africa's first downhill toboggan park. Rides never expire, sharing is allowed and buying online saves you 10%.",
    keywords:
      "Cool Runnings prices, toboggan prices Cape Town, Cool Runnings ticket prices, family attraction prices Cape Town, toboggan combo deals, school group rates Cape Town",
    image: "/og/pricing.jpg",
  });
  return (
    <>
      <PageHeader
        goodgirlTitle
        pageName="Pricing"
        eyebrow="Tickets & fares 2026 / 2027"
        title="PRICING"
        subline="Pay per person, per ride — rides are shareable and never expire. Prices are valid until 30 September 2027."
        image="/park-track.jpg"
        mascot={[
          "Howzit! Tokens from R110 — save 10% online!",
          "Rider tokens never expire, you know!",
          "Rides are shareable — bring the whole crew!",
        ]}
      />
      <Pricing />
      <CtaBand />
    </>
  );
}
